<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <dl class="row">
    <div class="container">
      <div class="dialog-title">Add to Hunt Template</div>
      <div class="dialog-subtitle">
        Add up to 25 hunt packages to each hunt template.
      </div>
      <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      <kendo-formfield>
        <label for="huntTemplate">Hunt Template</label>
        <kendo-combobox
          #combo
          [formControl]="huntTemplate"
          [data]="huntTemplateData"
          [filterable]="true"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          (selectionChange)="onSelectionChange($event)"
        >
        </kendo-combobox>
      </kendo-formfield>
      <button
        themeColor="primary"
        class="dialog-button"
        size="large"
        (click)="onSubmit()"
        [disabled]="!huntTemplate.valid"
        kendoButton
      >
        Save
      </button>
    </div>
  </dl>
</div>
